/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {agentGetCard} from '../api'

export const useMutationAgentGetCard = createReactQueryMutationHook('agentGetCard', agentGetCard)
